// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cw-b";
export var colorBlue = "_cw-8";
export var colorDot = "_cw-0";
export var colorDotLarge = "_cw-2";
export var colorDotSmall = "_cw-1";
export var colorGreen = "_cw-7";
export var colorGrey = "_cw-3";
export var colorOrange = "_cw-5";
export var colorPink = "_cw-a";
export var colorPurple = "_cw-9";
export var colorRed = "_cw-4";
export var colorYellow = "_cw-6";